export default __webpack_public_path__ + "static/media/logo_kss.5ed478c1.png";